import { render, staticRenderFns } from "./jikao.vue?vue&type=template&id=57ee8ae5&scoped=true"
import script from "./jikao.vue?vue&type=script&lang=js"
export * from "./jikao.vue?vue&type=script&lang=js"
import style0 from "./jikao.vue?vue&type=style&index=0&id=57ee8ae5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ee8ae5",
  null
  
)

export default component.exports